export enum ActionType {
    TEAMS_CALL__TCS__LOAD = 'TEAMS_CALL__TCS__LOAD',
    TEAMS_CALL__TCS__LOAD_RESULT = 'TEAMS_CALL__TCS__LOAD_RESULT',
    TEAMS_CALL__TCS__TOGGLE_CATEGORY = 'TEAMS_CALL__TCS__TOGGLE_CATEGORY',
    TEAMS_CALL__TCS__FILTER_SUMMARY = 'TEAMS_CALL__TCS__FILTER_SUMMARY',
}
